<h2 class="form-h2">Edit Company Profile</h2>
<form [formGroup]="form" (ngSubmit)="onSubmit()" (keydown.enter)="onSubmit()" autocomplete="off" style="margin-top: 8px">
  <div class="form-fields">
    <!-- Company Name Field -->
    <mat-form-field appearance="outline">
      <mat-label>Company Name</mat-label>
      <input matInput type="text" formControlName="companyName" placeholder="Ex. 2sic Programming" required data-lpignore="true" autocomplete="off" />
      @if (companyName.hasError("required")) {
        <mat-error> Company Name Required </mat-error>
      }
    </mat-form-field>

    <!-- Address Field -->
    <mat-form-field appearance="outline">
      <mat-label>Address</mat-label>
      <textarea matInput formControlName="address" placeholder="Ex. Langäulistrasse 62" data-lpignore="true" autocomplete="off" rows="3"> </textarea>
    </mat-form-field>

    <!-- Zip, City Field -->
    <mat-form-field appearance="outline">
      <mat-label>Zip, City</mat-label>
      <input matInput type="text" formControlName="zipCity" placeholder="Ex. 9470, Buchs SG" data-lpignore="true" autocomplete="off" />
    </mat-form-field>

    <!-- Country Field -->
    <mat-form-field appearance="outline">
      <mat-label>Country</mat-label>
      <input matInput type="text" formControlName="country" placeholder="Ex. CH" data-lpignore="true" autocomplete="off" />
    </mat-form-field>

    <!-- Phone Field -->
    <mat-form-field appearance="outline">
      <mat-label>Phone</mat-label>
      <input matInput type="text" formControlName="phoneNumber" placeholder="Ex. 079... +4179..." data-lpignore="true" autocomplete="off" />
      @if (phoneNumber.hasError("phoneInvalid")) {
        <mat-error> Phone Number Invalid </mat-error>
      }
    </mat-form-field>
  </div>
</form>

@if (apiErrorMessage()) {
  <div class="alert-danger" style="margin-top: 24px">
    Edit Company Error
    {{ apiErrorMessage() }}
  </div>
}

<div class="form-action-btn">
  <button mat-raised-button (click)="routeBack()">Cancel</button>
  <button mat-flat-button cdkFocusInitial [disabled]="form.invalid || saveState()" (click)="onSubmit()">Update</button>
</div>
